import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { BankAccount } from '../../views/banking/models/bank-account';
import { PaylineAccount } from '../../views/banking/models/payline-account';
import { PaymentMethodType } from '../shared/payment-method-type';
import { PaymentMethodTypeIdEnum } from '../enum/shared/payment-method-type-id.enum';
import { VariableBenefitDestinationJurisdictionDetail } from './variable-benefit-destination-jurisdiction-detail';
import { WithdrawalInstruction } from './withdrawal-instruction';

export class VariableBenefitPaymentChangeSubmissionData implements Deserializable {
  public paymentMethodId!: PaymentMethodTypeIdEnum | null;
  public paymentMethod!: PaymentMethodType | null;
  public bankAccountId!: number | null;
  public bankAccount!: BankAccount | null;
  public paylineAccountId!: number | null;
  public paylineAccount!: PaylineAccount | null;
  public targetRecurringPaymentAmount!: number | null;
  public recurringPaymentFrequencyId!: number | null;
  public recurringPaymentStartDate!: string | null;
  public lumpSumPaymentDesiredPaymentDate!: string | null;
  public recurringPaymentFrequency!: BaseType | null;
  public jurisdictionDetails!: VariableBenefitDestinationJurisdictionDetail[];
  public withdrawalInstructions!: WithdrawalInstruction[];

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.paymentMethod) {
      this.paymentMethod = Deserialize.instanceOf(PaymentMethodType, this.paymentMethod);
    }

    if (this.bankAccount) {
      this.bankAccount = Deserialize.instanceOf(BankAccount, this.bankAccount);
    }

    if (this.paylineAccount) {
      this.paylineAccount = Deserialize.instanceOf(PaylineAccount, this.paylineAccount);
    }

    if (this.jurisdictionDetails) {
      this.jurisdictionDetails = Deserialize.arrayOf(
        VariableBenefitDestinationJurisdictionDetail,
        this.jurisdictionDetails
      );
    }

    if (this.withdrawalInstructions) {
      this.withdrawalInstructions = Deserialize.arrayOf(WithdrawalInstruction, this.withdrawalInstructions);
    }
  }
}
